import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from 'vue-property-decorator';
import { $get } from '@/lib/helpers';

export type TableSortState = {prop: string; order: string; lblFn?: Function};

@Component
export default class XTable<T> extends Vue {

  public sortState: TableSortState = null;

  @Prop({type: Array, required: true}) readonly data!: T[];
  @Prop({type: Boolean, required: false, default: true}) readonly sortAuto!: boolean;
  @Prop({required: false}) readonly defaultSortState: TableSortState;

  get dataSorted() {
    const { prop, order, lblFn } = this.sortState;
    if (this.sortAuto && prop && order) {
      //detect data type
      const [ type ] = this.data
        .filter(d => $get(d, prop) != null)
        .slice(0, 1)
        .map(d => typeof $get(d, prop));
      return [...(this.data || [])].sort((a, b) => {
        const s = order === "desc" ? -1 : 1;
        if (type === "string") {
          return $get(a, prop).localeCompare($get(b, prop)) * s;
        } else if (type === "number") {
          return ($get(a, prop) - $get(b, prop)) * s;
        } else if (type === "object") {
          return lblFn($get(a, prop)).localeCompare(lblFn($get(b, prop)));
        }
      });
    } else {
      return [...(this.data || [])];
    }
  }

  created() {
    this.sortState = this.defaultSortState || {prop: null, order: null};
  }

  @Watch("defaultSortState")
  onDefautlSortValueChange(next) {
    this.sortState = next;
  }

  onSortTh(prop, lblFn) {
    const orders = ["asc", "desc", null];
    const nextIdx = prop === this.sortState.prop ? (orders.indexOf(this.sortState.order) + 1) % 3 : 0;
    this.sortState = {prop: orders[nextIdx] && prop, order: orders[nextIdx], lblFn};
    this.$emit("sort", this.sortState);
  }

  render() {
    let classes = ["table", "x-table"];

    const ths = this.$scopedSlots.header({dataRef: this.data});

    const noResColSpan = ths[0].children.length;

    return (
      <table class={classes.join(" ")}>
        {this.$scopedSlots.header && <thead>{ths}</thead>}
        {this.$scopedSlots.row && (
          <tbody>
            {this.dataSorted.length > 0 ? (
              this.dataSorted.map((d, i) => this.$scopedSlots.row({d, i, dataRef: this.data}))
            ) : (
            <tr>
              <td class="has-text-centered has-text-grey-light" colspan={noResColSpan}>
                {(this.$scopedSlots.noResult?.(undefined)) || 'Aucun résultat'}
              </td>
            </tr>
            )}
          </tbody>
        )}
      </table>
    );
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-c4c847e4/index.tsx" });